import { useReducer } from 'react';
import { ADD_ACTION, GET_API } from '../utilities/constants';
import { getHttpRequest } from './actions';
import GlobalContext from './global-context';

const defaultGlobalState = {
  items: [],
  totalAmount: 0,
  meals: [],
  data: false
};

const globalReducer = (state, action) => {
  console.log('globalReducer.action', action);
  if (action.type === ADD_ACTION) {
    const updatedItems = [...state.items];
    updatedItems.push(action.item);

    return {
      ...state,
      items: updatedItems,
    };
  }

  if (action.type === GET_API) {
    return {
      ...state,
      data: action.item
    };
  }

  return defaultGlobalState;
};

const GlobalProvider = (props) => {
  const [globalState, dispatchGlobalAction] = useReducer(
    globalReducer,
    defaultGlobalState
  );

  const addItemToGlobalHandler = (item) => {
    console.log('addItemToGlobalHandler.item', item);
    dispatchGlobalAction({ type: ADD_ACTION, item: item });
  };

  const getApiHandler = async () => {
    console.log('getApiHandler.item');
    const demoData = await getHttpRequest();

    dispatchGlobalAction({ type: GET_API, item: demoData });
  };

  const globalContext = {
    items: globalState.items,
    meals: globalState.meals,
    totalAmount: globalState.totalAmount,
    data: globalState.data,
    addItem: addItemToGlobalHandler,
    getApi: getApiHandler,
  };

  return (
    <GlobalContext.Provider value={globalContext}>
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalProvider;